const JSON_LOC = 'https://webdcr.com/itunes.json';
export default JSON_LOC;
